import React, { useEffect, useState } from "react";
import apiClient from "../../lib/api_client";
import { useQueries, useQueryClient } from "@tanstack/react-query";
import { formatTrayName } from "../../utils/formatTrayName";
import OccupiedTraySkeleton from "../../components/ui/skeletons/OccupiedTraySkeleton";
import OccupiedTray from "./OccupiedTray";
import { Skeleton } from "@mui/material";
import LogoutandDeleteModal from "../../components/ui/modals/LogoutandDeleteModal/LogoutandDeleteModal";

const StockMain = () => {
  const [openConfirmModal, setOpenConfirmModal] = useState({
    open: false,
    data: { trayName: "", salesPersonName: "", id: "" },
  });

  const getOccupiedTray = async () => {
    const response = await apiClient.get("/getAllOccupiedTray");
    return response?.data?.data;
  };
  const queryClient = useQueryClient();

  const getAvailableTray = async () => {
    const response = await apiClient.get("/trayAvl");
    return response?.data;
  };

  const sendRequest = async (id, trayName) => {
    await apiClient
      .post("/trayReceivedMessageForcefully", { id, trayName })
      .then((res) => {
        setOpenConfirmModal({
          open: false,
          data: { trayName: "", salesPersonName: "", id: "" },
        });
      })
      .catch((err) => {
        console.error("Error sending request:", err);
      });
  };

  const results = useQueries({
    queries: [
      {
        queryKey: ["occupiedTray"],
        queryFn: getOccupiedTray,
      },
      {
        queryKey: ["availableTray"],
        queryFn: getAvailableTray,
      },
      {
        querKey: ["recievedTray"],
        queryFn: () => sendRequest(),
      },
    ],
  });

  const occupiedTrayData = results[0]?.data;
  const occupiedTrayLoading = results[0]?.isLoading;
  const availableTrayData = results[1]?.data?.data;
  const availableTrayLoading = results[1]?.isLoading;

  const handleReceiveAction = () => {
    apiClient.put(`/request/${openConfirmModal?.data?.id}`, { action: "received" });
    sendRequest(
      openConfirmModal?.data?.id,
      openConfirmModal?.data?.trayName
    );
    queryClient.invalidateQueries(["occupiedTray", "availableTray", "recievedTray"])
  }

  return (
    <>
      <div>
        <p
          style={{
            fontFamily: "Poppins",
            fontWeight: 500,
            fontSize: "0.9vw",
            color: "#FFFFFF",
            marginBottom: "0.8vw",
          }}
        >
          Occupied tray
        </p>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "1vw",
          }}
        >
          {occupiedTrayLoading
            ? Array.from({ length: 3 }).map((_, i) => (
              <OccupiedTraySkeleton key={i} />
            ))
            : occupiedTrayData?.map((data) => (
              <OccupiedTray
                key={data._id}
                data={data}
                setOpenConfirmModal={setOpenConfirmModal}
              />
            ))}
        </div>
      </div>
      <div
        style={{
          marginTop: "1.6vw",
        }}
      >
        <p
          style={{
            fontFamily: "Poppins",
            fontWeight: 500,
            fontSize: "0.9vw",
            color: "#FFFFFF",
            marginBottom: "0.8vw",
          }}
        >
          Available tray
        </p>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "1vw",
          }}
        >
          {availableTrayLoading ? (
            <div
              style={{
                backgroundColor: "#0D0D0D",
                minWidth: "10.25vw",
                maxWidth: "10.25vw",
                padding: "1vw",
                borderRadius: "0.25vw",
                fontFamily: "Poppins",
                display: "flex",
                alignItems: "center",
                height: "2.2vw",
              }}
            >
              <Skeleton
                variant="text"
                width="80%"
                height={24}
                sx={{ bgcolor: "#222" }}
              />
            </div>
          ) : (
            availableTrayData?.map((data, _i_) => {
              return (
                <p
                  key={data._id}
                  style={{
                    backgroundColor: "#0D0D0D",
                    minWidth: "10.25vw",
                    maxWidth: "10.25vw",
                    padding: "1vw",
                    color: "white",
                    borderRadius: "0.25vw",
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    fontSize: "0.8vw",
                  }}
                >
                  {formatTrayName(data)}
                </p>
              );
            })
          )}
        </div>

        <LogoutandDeleteModal
          openModal={openConfirmModal.open}
          handleClose={() =>
            setOpenConfirmModal({
              open: false,
              data: { trayName: "", salesPersonName: "", id: "" },
            })
          }
          data={openConfirmModal.data}
          modalType="managerRequestConfirmation"
          onAction={handleReceiveAction}
        />
      </div>
    </>
  );
};

export default StockMain;